import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const BottomNav: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // 로그인/회원가입 페이지에서는 하단 내비 숨김
  const hideNav = ['/login', '/register'].includes(location.pathname);
  
  if (hideNav) return null;

  const handleHomeClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (location.pathname === '/') {
      // 이미 홈이면 최상단으로 스크롤
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      // 다른 페이지면 홈으로 이동
      navigate('/');
    }
  };

  const handleLottoClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (location.pathname === '/lotto') {
      // 이미 로또 페이지면 최상단으로 스크롤
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      // 다른 페이지면 로또로 이동
      navigate('/lotto');
    }
  };

  const handleSwapClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (location.pathname === '/swap') {
      // 이미 스왑 페이지면 최상단으로 스크롤
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      // 다른 페이지면 스왑으로 이동
      navigate('/swap');
    }
  };

  const handleSchedulerClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (location.pathname === '/scheduler') {
      // 이미 스케줄러 페이지면 달력 섹션으로 스크롤
      const calendarSection = document.getElementById('calendar-section');
      if (calendarSection) {
        calendarSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } else {
      // 다른 페이지면 스케줄러로 이동
      navigate('/scheduler');
    }
  };

  const navItems = [
    { path: '/', icon: '🏠', label: '홈', onClick: handleHomeClick },
    { path: '/scheduler', icon: '📅', label: '스케줄러', onClick: handleSchedulerClick },
    { path: '/lotto', icon: '🎲', label: '로또', onClick: handleLottoClick },
    { path: '/swap', icon: '🤝', label: '스왑', onClick: handleSwapClick },
  ];

  return (
    <nav
      className="bg-white border-t-2 border-primary/20 shadow-lg pb-4"
      style={{ paddingBottom: 'calc(1rem + env(safe-area-inset-bottom))' }}
    >
      <div className="container mx-auto px-2 py-3">
        <div className="flex items-center justify-around">
          {navItems.map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <Link
                key={item.path}
                to={item.path}
                onClick={item.onClick}
                className={`flex flex-col items-center justify-center px-3 py-2 rounded-lg transition-all ${
                  isActive
                    ? 'bg-primary text-white scale-105'
                    : 'text-gray-600 hover:bg-gray-100'
                }`}
              >
                <span className="text-xl mb-1">{item.icon}</span>
                <span className="text-xs font-medium">{item.label}</span>
              </Link>
            );
          })}
        </div>
      </div>
    </nav>
  );
};

export default BottomNav;
